function initialiseProjectsOverlay() {
  const selectedProjects = document.querySelectorAll('[data-project-name]');

  selectedProjects.forEach(projectElement => {
    const taglineElement = projectElement.querySelectorAll('.selected-project__content');
    const bubbleElement = projectElement.querySelectorAll('.selected-project__bubble');

    if (taglineElement.length === 0) {
      return;
    }

    // Initially hide tagline elements
    gsap.set(taglineElement, {
      opacity: 0,
      visibility: 'hidden'
    });
    gsap.set(bubbleElement, {
      opacity: 0,
      visibility: 'hidden'
    });

    // Use GSAP ScrollTrigger to detect when viewport middle is within the element
    ScrollTrigger.create({
      trigger: projectElement,
      start: "top 50%",      // When top of element hits middle of viewport
      end: "bottom 50%",     // When bottom of element hits middle of viewport
      onEnter: () => {
        gsap.to(taglineElement, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.3,
          ease: "power2.out"
        });
      },
      onLeave: () => {
        gsap.to(taglineElement, {
          opacity: 0,
          visibility: 'hidden',
          duration: 0.3,
          ease: "power2.in"
        });
      },
      onEnterBack: () => {
        gsap.to(taglineElement, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.3,
          ease: "power2.out"
        });
      },
      onLeaveBack: () => {
        gsap.to(taglineElement, {
          opacity: 0,
          visibility: 'hidden',
          duration: 0.3,
          ease: "power2.in"
        });
      }
    });

    ScrollTrigger.create({
      trigger: projectElement,
      start: "top bottom",
      end: "bottom bottom",
      onEnter: () => {
        gsap.to(bubbleElement, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.3,
          ease: "power2.out"
        });
      },
      onLeave: () => {
        gsap.to(bubbleElement, {
          opacity: 0,
          visibility: 'hidden',
          duration: 0.3,
          ease: "power2.in"
        });
      },
      onEnterBack: () => {
        gsap.to(bubbleElement, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.3,
          ease: "power2.out"
        });
      },
      onLeaveBack: () => {
        gsap.to(bubbleElement, {
          opacity: 0,
          visibility: 'hidden',
          duration: 0.3,
          ease: "power2.in"
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const bubbles = document.querySelectorAll('.selected-project__bubble');

  // Prevent click propagation on bubbles
  bubbles.forEach(bubble => {
    bubble.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!event.target.closest('.selected-project__bubble-inner')) {
        event.preventDefault();
      }
    });
  });

  // Initialize all selected projects on the page
  initialiseProjectsOverlay();
});
